import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-brand-cream" data-id="element-86">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-88">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-beige text-brand-navy font-semibold text-sm mb-6 uppercase tracking-wider" data-id="element-89">
            Para dueños de perros
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-navy leading-tight mb-6" data-id="element-90">
            ¿Le das comida casera a tu perro pero no sabes si realmente es
            segura para él?
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-91">
            Descubre cómo preparar recetas caseras simples, organizarte mejor y
            cuidar lo que come tu perro con una guía práctica y 5 herramientas
            digitales listas para usar desde hoy.
          </p>

          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 mb-10 inline-block border border-brand-beige shadow-soft" data-id="element-92">
            <p className="text-brand-navy font-semibold text-lg md:text-xl" data-id="element-93">
              <span className="text-brand-orange" data-id="element-94">✓</span> Sin ingredientes
              complicados. <span className="text-brand-orange" data-id="element-95">✓</span> Sin
              dietas imposibles. <span className="text-brand-orange" data-id="element-96">✓</span>{' '}
              Sin miedo a equivocarte.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-97">
            <CTAButton data-id="element-98">Quiero el pack completo por solo $6.36</CTAButton>
            <p className="text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-99">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-100"></span>
              Acceso digital inmediato después de tu compra. Sin envío físico.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-0 pointer-events-none" data-id="element-101">
        <div className="absolute -top-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-brand-orange/5 blur-3xl" data-id="element-102"></div>
        <div className="absolute top-[20%] -left-[10%] w-[30%] h-[30%] rounded-full bg-brand-green/5 blur-3xl" data-id="element-103"></div>
      </div>
    </section>;
}